
function GardaseeContext() {
    this.language = null;
    this.funnel = undefined;
    this.GACustomVarSlot = undefined;
    this.GACustomVarName = undefined;
    this.GACustomVarValue = undefined;
    this.GACustomVarScope = undefined;
    //this.GaTrackingLabel = '';
    this.MinWidthResponsive = 768;
    this.map = undefined;
    this.mapId = 'map';
    this.isAccosPage = false;
    this.noHeader = false;
}

window.gardaseeContext = $.extend(new GardaseeContext(), window.gardaseeContext);

$(document).ready(function() {

    setup_heroFixed();

    $('#enquiryqb-arrival').RangeDatepick({
        inputFrom: '#enquiryqb-arrival',
        inputTo: '#enquiryqb-departure',
        elementToFocusOnClose: '#enquiryqb-enquirysent',
        maxMonthsToShow: 2,
        lang: gardaseeContext.language
    });


    $("img[data-src!='']").each(function() {
        $(this).attr("src", $(this).data("src"));
    });

    $("img[data-href!='']").each(function() {
        $(this).attr("href", $(this).data("href"));
    });

    $("[data-gotolink]").click(function() {
        gotoLink(this);
    });

    if ($(".rsHeader .rsContent").size() > 0) {
        $(".rsHeader").royalSlider({
            controlNavigation: 'none',
            imageScaleMode: 'fill',
            //imageAlignCenter:false,
            delay: 7000,
            autoPlay: {
                enabled: true,
                delay: 7000,
                pauseOnHover: false
            },
            transitionType: 'fade'
        });
    }
    if ($(".background .rsContent").size() > 0) {
        $(".background").royalSlider({
            controlNavigation: 'none',
            imageScaleMode: 'none',
            delay: 10000,
            autoScaleSlider: false,
            autoHeight: false,
            autoPlay: {
                enabled: true,
                delay: 7000,
                pauseOnHover: false
            },
            transitionType: 'fade'
        });
    }

    if ($('.mediastrip').size() > 0) {
        $('.mediastrip').mediastrip({ lazyLoading: false });
    }

    // Fix all checkboxes true false
    $('input[data-setbool]').on("change", function() {
        if (this.checked) {
            $(this).val("true");
        } else {
            $(this).val("false");
        }
    }).change();


    // live watch #bestPrice click
    $(document).on('click', '#bestPrice', function() {
        if ($("#bestPriceSection").is(":hidden")) {
            $("#bestPriceSection").slideDown();
        }
        else {
            $("#bestPriceSection").slideUp();
        }
    });

    BindGaTracking();
    //ScrollToHash();

    FancyboxDefaults();
});


function setup_heroFixed() {
    var $topmenu = $('.topmenu');
    var $enquirybar = $('.enquirybar');
    var $accobar = $('.accobar');

    var $body = $('body');
    var $window = $(window);

    var enquirybarStickyOffset = 0;
    var accobarStickyOffset = 0;

    if ($enquirybar.size() > 0) {
        enquirybarStickyOffset = ($enquirybar.offset().top) - ($topmenu.height());

        // fix for noheader pages
        if (gardaseeContext.noHeader && parseInt($enquirybar.offset().top - $window.scrollTop()) == 90) {
            enquirybarStickyOffset = -1;
        }
    }

    if ($accobar.size() > 0) {
        accobarStickyOffset = ($accobar.offset().top - $window.scrollTop()) - ($topmenu.height()) - $enquirybar.height();
    }

    var heroFixed = function () {
        var y = $window.scrollTop();

        // Wenn auf AccosPage
        if (y > enquirybarStickyOffset) {
            $body.addClass('hero-fixed');
            $enquirybar.css('top', $topmenu.outerHeight());
        } else {
            $enquirybar.css('top', '');
            $body.removeClass('hero-fixed');
        }

        // Wenn auf AccoPage
        if ($accobar.size() > 0) {
            if (y >= accobarStickyOffset) {
                $body.addClass('accobar-fixed');
                $accobar.css('top', $topmenu.outerHeight());
            } else {
                $body.removeClass('accobar-fixed');
            }
        }

        // um die navbar tu verkleinern
        if (y >= 400) {
            $body.addClass('navbar-small');
        } else {
            $body.removeClass('navbar-small');
        }
    };

    // um die berechnung für jedes frame durchzuführen, weil onscroll zu langsam ist.
    requestAnimationFrame(function heroFixedCalculation() {
        heroFixed();
        requestAnimationFrame(heroFixedCalculation);
    });
    /* ------- */
}

// Goto LINK - Sucht nächstliegendes a tag und linkt dahin
function gotoLink(htmlElement) {

    var destinationURL = "";
    var target = "";

    if (htmlElement.href) {
        destinationURL = htmlElement.href;
        target = htmlElement.getAttribute("target");
    } else {
        if (htmlElement.childNodes) {
            if (htmlElement.getElementsByTagName("a")) {
                destinationURL = htmlElement.getElementsByTagName("a")[0].href;
                target = htmlElement.getElementsByTagName("a")[0].getAttribute("target");
            }
        }
    }

    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        var referLink = document.createElement('a');
        referLink.href = destinationURL;
        referLink.target = target;
        document.body.appendChild(referLink);
        referLink.click();
    } else if (target == "_blank") {
        window.open(destinationURL);
    } else {
        location.href = destinationURL;
    }
}

//trick um bei ipad das hover zu aktivieren:
document.addEventListener('touchstart', function(e) {
}, false);


function SetValidationAttributes() {
    var $jQval = $.validator,
        adapters,
        data_validation = "unobtrusiveValidation";

    function setValidationValues(options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    }

    $jQval.addMethod("selectnone", function(value, element, param) {
        // check if dependency is met
        if (!this.depend(param, element))
            return "dependency-mismatch";
        return element.checked;
    });

    $.validator.unobtrusive.adapters.add("selectnone", function(options) {
        setValidationValues(options, "selectnone", true);
    });

    $jQval.unobtrusive.parse();
}

function OpenModal(title, content) {
    var dynModal = $('#myModal');
    dynModal.find("#myModalLabel").html(title);
    dynModal.find(".modal-body").html(content);
    SetModalSize('#myModal', 'large');
    dynModal.modal('show');

    $(dynModal).find('[data-src!=""]').each(function() {
        $(this).attr("src", $(this).data("src"));
    });
}

function SetModalSize(id, type) {
    var dynModal = $(id);
    if (type == "small") {
        $(dynModal).addClass("modal-small");
        $(dynModal).removeClass("modal-large");
    } else {
        $(dynModal).removeClass("modal-small");
        $(dynModal).addClass("modal-large");
    }
}


function BindGaTracking() {
    $('a[data-gaq]').unbind('click', GaTrackEvent);
    $('a[data-gaq]').bind('click', GaTrackEvent);
}

function GaTrackEvent() {
    var data = ($(this).attr('gaq') || $(this).data('gaq')).split("|");
    var cat = data[0];
    var act = data[1];
    var lab = data[2];
    window.siteEvent(cat, act, lab);
}

function linkImage(htmlElement) {
    var destinationURL = "";
    var target = "";

    if (htmlElement.href) {
        destinationURL = htmlElement.href;
        target = htmlElement.getAttribute("target");
    }
    else {
        if ($(htmlElement).find(".themeteaser-title").length > 0) {
            destinationURL = $(htmlElement).find(".themeteaser-title").find("a").attr("href");
            target = $(htmlElement).find(".themeteaser-title").find("a").attr("target");
        }
        else{
            destinationURL = $(htmlElement).find(".accotypeTeaser-title").find("a").attr("href");
            target = $(htmlElement).find(".accotypeTeaser-title").find("a").attr("target");
        }
    }

    if (target == "_blank") {
        window.open(destinationURL);
    }
    else {
        location.href = destinationURL;
    }
}

function ScrollToHash() {
    var hash = document.location.hash;
    if (hash != "") {

        var hashSplitted = hash.split("|");
        DisableClick($(hashSplitted[0]).parent());
        DisableClick($('a[href^=' + hashSplitted[0] + ']').parent());

        $('a[href^=' + hashSplitted[0] + ']').click();

        $(hashSplitted[0]).click();
        //alert(hashSplitted.length);
        for (var i = 0; i < hashSplitted.length; i++) {

            //if (i > 0 && (hash.indexOf("accobook") == -1 || hash.indexOf("package") == -1)) {
            if (i > 0) {
                if ($('#' + hashSplitted[i]).length > 0) {
                    $.scrollTo($('#' + hashSplitted[i]), 1000, { offset: -250 });
                    $('#' + hashSplitted[i]).css("background-color", "#FAFAFA");
                    $('#' + hashSplitted[i] + " .widget-left").css("padding-left", "8px");
                }
            } else {
                if ($(hashSplitted[i]).length > 0 && hashSplitted[i] != "#packages") {
                    $.scrollTo($(hashSplitted[i]), 1000, { offset: -150 });
                }
            }
        }

        EnableClick($(hashSplitted[0]).parent());
        EnableClick($('a[href^=' + hashSplitted[0] + ']').parent());
    }
}

function FancyboxDefaults() {
    const lang = gardaseeContext.language;
    const breakpointMd = 992;
    var options = {
        animationEffect: "zoom", // "fade"
        transitionDuration: 550,

        preventCaptionOverlap: true,

        protect: true, // Disable right-click and use simple image protection for images

        media: {
            // ICDAM providers
            peer: {
                matcher: /https?:\/\/(player\.peer\.tv)\/(js)\/([0-9a-z]+)/i,
                type: "inline",
                url: function (match, params, item) {
                    var id = match[3];
                    var url = 'https://player.peer.tv/js/' + id + '/?w=liquid-proportional'; // + '&a=1'; <- to auto play
                    item.opts.smallBtn = false; // hide close btn
                    return '<div class="fancybox__peer-video"><script src="' + url + '"></script></div>';
                }
            },
            feratel: {
                matcher: /https?:\/\/(webtv\.feratel\.com)\/(webtv)\/?\?.*\&cam=([0-9]+)/i,
                type: "iframe",
                url: 'https://webtv.feratel.com/webtv/?design=v3&cam=$3'
            },
            dailymotion: {
                matcher: /https?:\/\/(?:www\.)?(dailymotion\.com)\/video\/([^_]+)/i,
                type: "iframe",
                url: 'https://www.dailymotion.com/embed/video/$2?autoplay=1'
            },
            inetcons: { // obsolete
                matcher: /https?:\/\/(media\.inetcons\.it)\/(videos)\/(.+)\.(de|it|en)\.([0-9a-z]+)\.mp4/i,
                type: "iframe",
                url: 'https://media.inetcons.it/video/embed/$5?languageCode=$4&autoplay=true'
            },
            virtualSuedtirol: {
                matcher: /.*virtualsuedtirol\.com.*/i,
                type: 'iframe',
                url: '$0'
            },
            movingPictures: {
                matcher: /.*moving-pictures\.com.*/i,
                type: 'iframe',
                url: '$0'
            }
        },

        buttons: [
            "zoom",
            "share",
            "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
        ],
        arrows: true,
        infobar: true, // window.innerWidth >= scom.breakpoints.md.min, // on desktop
        thumbs: {
            autoStart: window.innerWidth >= breakpointMd, // on desktop, // Display thumbnails on opening
            hideOnClose: true, // Hide thumbnail grid when closing animation starts
            parentEl: ".fancybox-container", // Container is injected into this element
            //axis: "x" // Vertical (y) or horizontal (x) scrolling
        },
        lang: lang,
        i18n: {
            en: {
                CLOSE: "Close",
                NEXT: "Next",
                PREV: "Previous",
                ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                PLAY_START: "Start slideshow",
                PLAY_STOP: "Pause slideshow",
                FULL_SCREEN: "Full screen",
                THUMBS: "Thumbnails",
                DOWNLOAD: "Download",
                SHARE: "Share",
                ZOOM: "Zoom"
            },
            de: {
                CLOSE: "Schliessen",
                NEXT: "Weiter",
                PREV: "Zurück",
                ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                PLAY_START: "Diaschau starten",
                PLAY_STOP: "Diaschau beenden",
                FULL_SCREEN: "Vollbild",
                THUMBS: "Vorschaubilder",
                DOWNLOAD: "Herunterladen",
                SHARE: "Teilen",
                ZOOM: "Maßstab"
            },
            it: {
                CLOSE: "Chiudi",
                NEXT: "Avanti",
                PREV: "Indietro",
                ERROR: "Il contenuto richiesto non è disponibile. <br/> Si prega di riprovare più tardi.",
                PLAY_START: "Inizia presentazione",
                PLAY_STOP: "Ferma presentazione",
                FULL_SCREEN: "Schermo intero",
                THUMBS: "Anteprime",
                DOWNLOAD: "Scarica",
                SHARE: "Condividi",
                ZOOM: "Ingrandisci"
            }
        }
    };

    // set global options
    $.extend($.fancybox.defaults, options);
}
